

import { NgModule } from '@angular/core';
import { TnxSharedModule } from 'tnx-shared';
import { LogFormComponent } from './log-form/log-form.component';
import { LogComponent } from './log.component';
import { LogRoutes } from './log.routing';

export function declaration() {
    return [LogComponent, LogFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class LogModule {
}

@NgModule({
    imports: [LogModule, LogRoutes],
    exports: [LogModule]
})
export class LogWithRouteModule {
}
